import { render, staticRenderFns } from "./TickCross.vue?vue&type=template&id=3316f8a2&"
import script from "./TickCross.vue?vue&type=script&lang=ts&"
export * from "./TickCross.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3316f8a2')) {
      api.createRecord('3316f8a2', component.options)
    } else {
      api.reload('3316f8a2', component.options)
    }
    module.hot.accept("./TickCross.vue?vue&type=template&id=3316f8a2&", function () {
      api.rerender('3316f8a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/table/TickCross.vue"
export default component.exports